module.exports = __webpack_public_path__ + "assets/img/partner.67d82bcf.png";